import Entity from "./entity";
import Description from "./description";
import Item from "./item";
import Glyphs from "../glyphs";

class Ammunition {
  static ARROW = "arrow";
  static BOLT = "bolt";
  static DART = "dart";

  static needles(quantity) {
    return Ammunition.make(
      Glyphs.BluntArrow,
      "Blowgun Needles",
      "Dirty little metal spikes that fire from a blowgun.",
      "Feral",
      Ammunition.DART,
      4,
      quantity,
      30
    );
  }

  static bluntArrows(quantity) {
    return Ammunition.make(
      Glyphs.BluntArrow,
      "Blunt Arrows",
      "Sturdy hazel hunting arrows with blunted tips for stunning small game.",
      "Rustic",
      Ammunition.ARROW,
      4,
      quantity,
      30
    );
  }

  static barbedArrows(quantity) {
    return Ammunition.make(
      Glyphs.BarbedArrow,
      "Barbed Arrows",
      "Long thin missiles with deadly harpoon-like arrowheads.",
      "Warlike",
      Ammunition.ARROW,
      9,
      quantity,
      30
    );
  }

  static make(glyph, name, description, quality, type, damage, quantity, limit) {
    return new Entity(null, null, glyph, name, {
      description: new Description(description),
      item: new Item(quality),
      ammunition: new Ammunition(type, damage, quantity, limit)
    });
  }

  constructor(type, damage, quantity, limit) {
    this.type = type;
    this.damage = damage;
    this.quantity = quantity;
    this.limit = limit;
  }

  isFull() {
    return this.quantity == this.limit;
  }

  isEmpty() {
    return this.quantity == 0;
  }
}

export default Ammunition;
